import { removeFromPaginated } from '@sketch/modules-common'
import { ProjectCacheOperation } from '../operations/useProjectSubscriptions/utils'

export const handleProjectDeletedPermanently = (
  params: ProjectCacheOperation
) => {
  const { cache, identifier } = params

  // Remove the project from the trash query
  removeFromPaginated(cache, { __typename: 'Project', identifier }, key =>
    key.includes('workspaceTrash')
  )

  removeFromPaginated(
    cache,
    { __typename: 'TrashedProject', identifier },
    key => key.includes('workspaceTrash')
  )

  // Remove from storageItems, necessary for the `nested-projects` feature flag
  removeFromPaginated(
    cache,
    { __typename: 'Project', identifier },
    key => key.includes('storageItems') && key.includes('"source":"TRASH"')
  )
}
